import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { TenantProvider } from './context/TenantContext';
import { BreadcrumbProvider } from './context/BreadcrumbContext';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <BreadcrumbProvider>
          <AuthProvider>
            <TenantProvider>
              <App />
              <Toaster position="top-right" />
            </TenantProvider>
          </AuthProvider>
        </BreadcrumbProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
